export * from './constants';



// WEBPACK FOOTER //
// ./src/components/Modal/constants/ModalInactivity/index.ts